import SlotGroup from "@/types/SlotGroupInterface";
import {
  DateTimeInterface,
  DiscordUserInterface,
  ModpackInterface,
  PersistedEventInterface,
} from "@/types";
import moment from "moment-timezone";
import PersistedSlotGroupInterface from "@/types/PersistedSlotGroupInterface";
import axios from "@/plugins/customAxios";

export default class Event implements PersistedEventInterface {
  id: number;
  name: string;
  description: string;
  modpack: ModpackInterface;
  slotGroups: PersistedSlotGroupInterface[];
  date: DateTimeInterface;
  approved: boolean;
  owner: DiscordUserInterface;
  mainEvent: boolean;
  image?: string;
  finished: boolean;
  moderator?: DiscordUserInterface;
  reserve: DiscordUserInterface[];

  constructor(event: PersistedEventInterface) {
    this.id = event.id;
    this.name = event.name;
    this.description = event.description;
    this.modpack = event.modpack;
    this.slotGroups = event.slotGroups;
    this.date = event.date;
    this.approved = event.approved;
    this.owner = event.owner;
    this.mainEvent = event.mainEvent;
    this.image = event.image;
    this.finished = event.finished;
    this.reserve = [];
  }

  get localDateString() {
    const utcDate = moment.tz(
      this.date.date.substring(0, 23),
      this.date.timezone
    );

    return utcDate
      .clone()
      .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
      .format("dddd, MMMM Do YYYY, HHmm [hours]");
  }

  get eventUri(): string {
    return `/events/${this.name}`;
  }
  
  static async getEventImage(id: number) {
    const response = await axios.get("/arma/eventImages/" + id);

    return response.data;
  }
}
